<template>
  <div>
    <!-- 料金 masterBookSetがある場合は、masterBookSet.display_priceを表示-->
    <!-- バス無料チケットなどは無料でdisplay_priceがnullの場合があるのでif分岐が必要 -->
    <MbDisplaypriceDisp
      v-if="masterBook.display_price"
      :price="
        masterBookSet ? masterBookSet.display_price : masterBook.display_price
      "
    />
    <!-- 料金 -->

    <!-- 料金に関する注意-->
    <MbDisplaypriceCaution
      v-if="masterBook.display_price_comment"
      :comment="masterBook.display_price_comment"
    />
    <!-- 料金に関する注意-->
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TheMbPriceAndCaution",
  setup() {
    const store = useStore();
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const masterBookSet = computed(
      () => store.getters["ticketing/masterBookSet"]
    );

    return {
      masterBook,
      masterBookSet,
    };
  },
};
</script>
